import { PayloadAction } from '../../../store.model';
import { ActionType } from '../main.action';
import { MainState } from '../main.state';

import {
    HidePopulationGroupDialog,
    ShowPopulationGroupDialog,
} from './show-population-group-dialog.action';

export function showPopulationGroupDialogReducer(
    state: MainState,
    _: PayloadAction<
        ActionType.MI2_MAIN__SHOW_POPULATION_GROUP_DIALOG,
        ShowPopulationGroupDialog
    >,
): MainState {
    return {
        ...state,
        populationGroupDialogData: {
            populationGroupImprovementGroups:
                state.populationGroupImprovementGroups?.sort(
                    (a, b) => a.displayOrder - b.displayOrder,
                ),
        },
    };
}

export function hidePopulationGroupDialogReducer(
    state: MainState,
    _: PayloadAction<
        ActionType.MI2_MAIN__HIDE_POPULATION_GROUP_DIALOG,
        HidePopulationGroupDialog
    >,
): MainState {
    return {
        ...state,
        populationGroupDialogData: undefined,
    };
}
